import { createReducer } from '@reduxjs/toolkit';
import type { APIError } from '../actions/api-error';
import { CLEAR_API_ERROR, SHOW_API_ERROR } from '../actions/api-error';

type APIErrorState = {
  error: APIError;
};

const initState: APIErrorState = {
  error: null,
};

const apiErrorReducer = createReducer(initState, (builder) =>
  builder
    .addCase(SHOW_API_ERROR, (state, action) => ({ ...state, error: action.payload }))
    .addCase(CLEAR_API_ERROR, (state) => ({ ...state, error: null }))
);

export default apiErrorReducer;
